export const ACTION_NAME_ERROR = 'error';
export const ACTION_NAME_SUBMIT = 'submit';
export const ACTION_NAME_VIEW = 'view';

export const STEP_ID_ERROR = 5;
export const STEP_ID_SUBMIT = 3;
export const STEP_ID_VIEW = 1;

export const ARKOSE_CHALLENGE_V2 = 'arkose_v2.0';
